import React, { FunctionComponent, useEffect, useState } from 'react';
import DashboardLayout from '../../components/layout/layout';
import { Box, Button, Divider, Grid, Skeleton, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useGetInventory } from '../../hooks/api/user';
import moment from 'moment';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

type InventoryProps = {
  partNo: string;
  freshDate: string;
  qty: number;
  repName: string;
  repLocation: string;
  nodash: string;
  worktable: string;
}

const InventoryDetails: FunctionComponent = () => {
  const navigate = useNavigate();
  const { repName, partNo } = useParams();
  const [ inventoryData, setInventoryData ] = useState<InventoryProps | null>(null);
  const { data: inventory, isFetched: hasFetched } = useGetInventory({ partNo: partNo });
  const inventoryList: InventoryProps[] = Array.isArray(inventory?.data) ? inventory.data : [];

  useEffect(() => {
    if (inventoryList && inventoryList.length > 0) {
      const filteredInventory = inventoryList.filter((item: InventoryProps) => item.repName === repName);
      if (filteredInventory.length > 0) {
        setInventoryData(filteredInventory[0]);
      } else {
        setInventoryData(null);
      }
    }
  }, [inventory, repName]);

  return (
    <>
      <DashboardLayout titleIcon={<LockOutlinedIcon />} title={"Inventory"} initialBreadcrumbs={"Channel Partners"} levelBreadcrumbs={''} breadcrumbs={' Inventory Details'} activeMenu={'inventory'} isOverflow={true}>
        <Box sx={{ position: 'relative', width: '100%', maxWidth: '100%' }}>
          <SettingsOutlinedIcon
            sx={{
              position: 'absolute',
              bottom: '-7rem',
              right: '-5rem',
              fontSize: 280,
              color: 'rgba(0,0,0,0.05)',
              zIndex: 0,
              transform: 'rotate(30deg)',
            }}
          />
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Grid container spacing={4} alignItems="flex-start">
              {
                !hasFetched ? (
                  <>
                    <Skeleton width="38%" />
                    <Skeleton width="100%" />
                    <Skeleton width="100%" />
                    <Skeleton width="61%" />
                  </>
                ) : (
                  <>
                    {
                      inventoryData && (
                        <>
                          <Grid size={5}>
                            <Box display="flex" flexDirection="column" gap={1}>
                              <Typography variant="subtitle1" fontWeight="bold">
                                {inventoryData?.repName}
                              </Typography>
                              <Typography variant="subtitle2" color="textSecondary">
                                <div
                                  dangerouslySetInnerHTML={{ __html: inventoryData?.repLocation }}
                                  style={{ whiteSpace: 'pre-wrap' }}
                                />
                              </Typography>
                            </Box>
                          </Grid>

                          <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', md: 'block' } }} />

                          <Grid size={5}>
                            <Box display="flex" flexDirection="column" gap={2}>
                              <Box>
                                <Typography variant="subtitle2">Barksdale Part No.</Typography>
                                <Typography variant="subtitle2" fontWeight="bold">
                                  {inventoryData?.partNo}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant="subtitle2">Quantity in stock:</Typography>
                                <Typography variant="subtitle2" fontWeight="bold">
                                  {inventoryData?.qty}
                                </Typography>
                              </Box>
                              <Box>
                                <Typography variant="subtitle2">As of:</Typography>
                                <Typography variant="subtitle2" fontWeight="bold">
                                  {moment(inventoryData?.freshDate).format('MM/DD/YYYY')}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        </>
                      )
                    }
                  </>
                )
              }
            </Grid>

            <Box sx={{ mt: 3, textAlign: 'left' }}>
              <Button
                variant="contained"
                sx={{ backgroundColor: '#c3183c', px: 4 }}
                onClick={() => navigate(-1)}
              >
                BACK
              </Button>
            </Box>
          </Box>
        </Box>
      </DashboardLayout>  
    </>
  )
};

export default InventoryDetails;